export enum BorrowerSeperator {
  BORROWER = 'borrower',
  CO_BORROWER = 'coBorrower',
  CO_BORROWER2 = 'coBorrower2',
  CO_BORROWER3 = 'coBorrower3',
}

export const CoBorrowers: Array<string> = [
  BorrowerSeperator.CO_BORROWER,
  BorrowerSeperator.CO_BORROWER2,
  BorrowerSeperator.CO_BORROWER3,
]

export const BorrowerLabel: Record<string, string> = {
  [BorrowerSeperator.BORROWER]: 'Borrower 1',
  [BorrowerSeperator.CO_BORROWER]: 'Borrower 2',
  [BorrowerSeperator.CO_BORROWER2]: 'Borrower 3',
  [BorrowerSeperator.CO_BORROWER3]: 'Borrower 4',
}

export const BorrowerSeparatorList = [
  BorrowerSeperator.BORROWER,
  BorrowerSeperator.CO_BORROWER,
  BorrowerSeperator.CO_BORROWER2,
  BorrowerSeperator.CO_BORROWER3,
]
